/**
 * @flow
 * @relayHash c73828629fd3f7bbccc109e2cac6a12d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetPropertiesToUserInput = {
  userId?: ?string,
  properties?: ?$ReadOnlyArray<?PropertyInputType>,
  clientMutationId: string,
};
export type PropertyInputType = {
  id: string,
  values?: ?$ReadOnlyArray<?string>,
};
export type NewSetPropertiesToUserMutationVariables = {|
  input: SetPropertiesToUserInput
|};
export type NewSetPropertiesToUserMutationResponse = {|
  +setCustomPropertiesToUser: ?{|
    +user: ?{|
      +id: string,
      +pid: ?string,
      +hasAllRequiredInfo: ?boolean,
    |},
    +clientMutationId: string,
  |}
|};
*/


/*
mutation NewSetPropertiesToUserMutation(
  $input: SetPropertiesToUserInput!
) {
  setCustomPropertiesToUser(input: $input) {
    user {
      id
      pid
      hasAllRequiredInfo
    }
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetPropertiesToUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "setCustomPropertiesToUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SetPropertiesToUserInput!"
      }
    ],
    "concreteType": "SetPropertiesToUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "pid",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasAllRequiredInfo",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "NewSetPropertiesToUserMutation",
  "id": null,
  "text": "mutation NewSetPropertiesToUserMutation(\n  $input: SetPropertiesToUserInput!\n) {\n  setCustomPropertiesToUser(input: $input) {\n    user {\n      id\n      pid\n      hasAllRequiredInfo\n    }\n    clientMutationId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "NewSetPropertiesToUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "NewSetPropertiesToUserMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '00b61389aa9137e47a08c7fd8f85a3de';
module.exports = node;
